module.exports = __webpack_public_path__ + "scripts/icons.svg?7726a281";


//////////////////
// WEBPACK FOOTER
// ./semantic/dist/themes/default/assets/fonts/icons.svg
// module id = 1489
// module chunks = 1